import { Outlet } from 'react-router-dom';

// styles
import {
    ChecklistPageContainer,
    OutletContainer
} from './ChecklistPage.styles';

export default function ChecklistPage() {

    return (
        <ChecklistPageContainer>
            <OutletContainer>
                <Outlet />
            </OutletContainer>
        </ChecklistPageContainer>
    )
}
